var Flash = window.Flash;

export default class FlashNotification {

  constructor({element: element}) {
    this.$element = $(element);
    this.$body = $('body');
    this.notifications = {
        session_notice: $(".notification--session_notice"),
        notice: $(".notification--notice"),
        noticeCookie: $(".notification--notice__cookie"),
        warning: $(".notification--warning"),
        error: $(".notification--error"),
        parentDOM: $(".notification.js-component")
    };
  }

  init() {
    Flash.transferFromCookies();
    this.warning();
    this.sessionNotice();
    this.notice();
    this.noticeFromCookies();
    this.error();
    this.closeButton();
    this.removeHiddenClass();
  }

  notice() {
    if(Flash.data.notice !== undefined){
      Flash.writeDataTo('notice', this.notifications.notice);
    }
  }

  noticeFromCookies() {
    var cookieName = 'creator_notice_message=';
    var tempCookie = document.cookie.split(cookieName);
    if(tempCookie.length > 1) {
      var semicolonIndex = tempCookie[1].indexOf(';');
      semicolonIndex = (semicolonIndex == -1) ? tempCookie[1].length : semicolonIndex;
      var creatorNoticeMessage = tempCookie[1].substring(0, semicolonIndex).replace(/[+]/gi, ' ');
      creatorNoticeMessage = decodeURIComponent(creatorNoticeMessage);
      this.notifications.noticeCookie.html(creatorNoticeMessage).removeClass('hide-me');
      document.cookie = cookieName + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }

  sessionNotice() {
    if(Flash.data.session_notice !== undefined || Flash.data.session_notice !== null){
      Flash.writeDataTo('session_notice', this.notifications.session_notice);

      if(Flash.data.session_notice === "Signed in successfully") {
        this.$body.trigger('validation:sign_in:success');
      }

      this.hideSessionNoticeInFiveSeconds();
    }
  }

  hideSessionNoticeInFiveSeconds(){
    setTimeout(function() {
      this.hideSessionNotice();
    }.bind(this), 5000);
  }

  hideSessionNotice(){
    $('.notification--session_notice').css('display','none');
    this.notifications.parentDOM.removeClass('has-fixed-alert').addClass("hide-me");
  }

  warning() {
    var cookieName = 'creator_warning_message=';
    var tempCookie = document.cookie.split(cookieName);
    if(tempCookie.length > 1) {
      var semicolonIndex = tempCookie[1].indexOf(';');
      semicolonIndex = (semicolonIndex == -1) ? tempCookie[1].length : semicolonIndex;
      var creatorWarningMessage = tempCookie[1].substring(0, semicolonIndex).replace(/[+]/gi, ' ');
      creatorWarningMessage = decodeURIComponent(creatorWarningMessage);
      $(".notification--warning").html(creatorWarningMessage).removeClass('hide-me');

      document.cookie = cookieName + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  }

  error() {
    if(Flash.data.error !== undefined){
      Flash.writeDataTo('error', this.notifications.error);
    }
  }

  close() {
    this.$element.addClass('hide-me');
  }

  closeButton() {
    this.$element.find('.notification--close').on('click', this.close.bind(this) );
  }

  removeHiddenClass() {
    var isFixedAlertExist = $.trim($(".notification--session_notice").html()).length;
    
    if(this.notifications.parentDOM.height() || isFixedAlertExist) {
      this.notifications.parentDOM.removeClass("hide-me");

      if(isFixedAlertExist) {
        this.notifications.parentDOM.addClass('has-fixed-alert');
      }
    }
  }
}
